import React from "react";
import "../css/privacy.scss";

function Faqs() {
  return (
    <main role="main" id="MainContent" className="main-content">
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Frequently Asked Questions</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte">
            <p><strong>What materials do you use?</strong><br />Each product page lists the materials used for that piece. Our collection includes sterling silver, gold-finished details, natural stones, pearls and amber. Natural materials can vary slightly in colour and pattern.</p>
            <p><strong>Will my piece look exactly like the photograph?</strong><br />Small variations are part of the character of natural stones and handcrafted finishes. The product photographs show the design and overall appearance you can expect.</p>
            <p><strong>How should I care for my jewellery?</strong><br />Keep jewellery dry, avoid perfume and household chemicals, and store pieces separately in a soft pouch. Wipe gently with a clean, non-abrasive cloth after wear.</p>
            <p><strong>How long does delivery take?</strong><br />Available delivery methods and current estimates are shown on our Shipping Policy page and during checkout.</p>
            <p><strong>Can I return an order?</strong><br />Eligible, unworn items may be returned in accordance with our Returns Policy. Earrings and personalised items may be excluded for hygiene or customisation reasons.</p>
            <p><strong>Can I change or cancel an order?</strong><br />Email packs@houndandhome.xyz as soon as possible. We cannot guarantee changes after an order has entered fulfilment.</p>
            <p><strong>How can I contact Hound &amp; Home?</strong><br />Use our contact form or email packs@houndandhome.xyz. Please include your order number when asking about an existing order.</p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Faqs;
